import React, { forwardRef, Ref, SVGProps } from 'react'

function _IconFrameBarChart(props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props} ref={ref}>
      <rect width="24" height="24" rx="6" fill={props.fill ?? '#F2F5F7'} />
      <path
        d="M8.00002 15L13 15"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00002 12L16 12"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99998 9L11 9"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconFrameBarChart = forwardRef(_IconFrameBarChart)
